import { List } from 'immutable';
import { update as updateEvent } from '../../events/actions/update';
import { bulk as bulkSelections } from '../../selections/actions/update';
import addError from '../../../utils/error.jsx';

export function request(eventId, marketId, templateId, params) {
    if (!templateId) {
        addError('You have to choose selection template.');

        return () => {};
    }

    return {
        type: 'MARKETS_ADD_SELECTION_REQUEST',
        eventId,
        marketId,
        templateId,
        params
    };
}

export function error(marketId, errors) {
    addError(errors);

    return {
        type: 'MARKETS_ADD_SELECTION_ERROR',
        errors,
        marketId
    };
}

export function finish(marketId, market) {
    return (dispatch) => {
        dispatch({
            type: 'MARKETS_ADD_SELECTION_FINISH',
            market,
            marketId
        });
    };
}
